import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import WatchIcon from '@mui/icons-material/Watch';
import ClearIcon from '@mui/icons-material/Clear';

const TicketsFilter = () => {
 
  const initTicketsFilters = () => dispatch(getTicketsFilters());
  const { inmuebles, regiones, grupos, filtersSelected } = useSelector((state) => state?.fuse?.dashboard?.dashboard?.filters);

  const [inmueble, setInmueble] = useState('');
  const [region, setRegion] = useState('');
  const [grupo, setGrupo] = useState('');

  useEffect(() => {
    initTicketsFilters();
  }, []);

  const handleFilterSelected = (filterCategory, filterToAdd) => {
    if (filterCategory === 'region') {
      setRegion(filterToAdd);
    } else if (filterCategory === 'inmueble') {
      setInmueble(filterToAdd);
    } else {
      setGrupo(filterToAdd);
    }

    dispatch(setTicketsFiltersSelected(filtersSelected, { [filterCategory]: filterToAdd }));
  };

   const handleClearFilters = () => {
    setRegion('');
    setInmueble('');
    setGrupo('');
    dispatch(setTicketsFiltersSelected({}, null));
  };
  
  return (
    <Grid container className="bg-white rounded-lg mb-8 p-10" style={{ width: '100%' }}>
      <Grid item xs={12} sm={12} md={9} lg={9} className="flex flex-row justify-start align-middle">
        <FormControl sx={{ minWidth: 120, marginRight: 5 }}>
          <InputLabel id="tiempo-select-label">Tiempo</InputLabel>
          <Select labelId="tiempo-select" id="tiempo-select" label="Tiempo" defaultValue="">
            <MenuItem value={1}>1 Hora</MenuItem>
            <MenuItem value={2}>1 Día</MenuItem>
            <MenuItem value={3}>1 Semana</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 120, marginRight: 5 }}>
          <InputLabel id="region-select-label">Región</InputLabel>
          <Select
            labelId="region-select"
            id="region-select"
            label="Region"
            defaultValue=""
            value={region}
            onChange={(e) => handleFilterSelected('region', e.target.value)}
          >
            {regiones.map((currentRegion, index) => (
              <MenuItem key={index} value={currentRegion.regionId}>
                {currentRegion.dsRegion}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 120, marginRight: 5 }}>
          <InputLabel id="grupo-select-label">Grupo</InputLabel>
          <Select
            labelId="grupo-select"
            id="grupo-select"
            label="Grupo"
            value={grupo}
            defaultValue=""
            onChange={(e) => handleFilterSelected('grupo', e.target.value)}
          >
            {grupos.map((currentGrupo, index) => (
              <MenuItem key={index} value={currentGrupo.grupoinmuebleid}>
                {currentGrupo.dsgrupoinmueble}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 120, marginRight: 5 }}>
          <InputLabel id="inmueble-select-label">Inmueble</InputLabel>
          <Select
            labelId="inmueble-select"
            id="inmueble-select"
            label="Inmueble"
            value={inmueble}
            defaultValue=""
            onChange={(e) => handleFilterSelected('inmueble', e.target.value)}
          >
            {inmuebles.map((currentInmueble, index) => (
              <MenuItem key={index} value={currentInmueble.inmuebleid}>
                {currentInmueble.dsinmueble}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} className="flex flex-row justify-end" sx={{ alignItems: 'center' }}>
        <Button variant="outlined" style={{ borderRadius: '8px', fontSize: '12px' }} startIcon={<WatchIcon />}>
          Actualizar Ahora
        </Button>
        <IconButton aria-label="clear-filters" style={{}} onClick={handleClearFilters}>
          <ClearIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default TicketsFilter;
